type FeaturedEventAction = 'pin_control_clicked' | 'highlight_cleared' | 'replacement_confirmed';

export function trackFeaturedEventAction(
  action: FeaturedEventAction,
  organizerId: string,
  eventId: string,
) {
  if (typeof window === 'undefined') return;
  const target = window as typeof window & { dataLayer?: Array<Record<string, string>> };
  target.dataLayer ??= [];
  target.dataLayer.push({
    event: 'organizer_profile_featured_event',
    action,
    organizer_id: organizerId,
    event_id: eventId,
    entry_point: 'organizer_profile',
  });
}
